import React from 'react';
import useTranslation from '../../../util/hooks/useTranslation';
import WidgetSettingModal from '../Components/WidgetSettingModal';

const TagSummarySetting = ({ widgetInfo, ...restProps }) => {
    const t = useTranslation('TagSummaryWidget');
    return (
        <WidgetSettingModal
            headerTitle={t('Tag summary widget setting')}
            widgetInfo={widgetInfo}
            hiddenHeader
            {...restProps}
        />
    );
};

export default TagSummarySetting;
